var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card2 contact-person" }, [
    !_vm.isEmpty && _vm.editable
      ? _c("div", { staticClass: "pull-right" }, [
          _c(
            "a",
            {
              staticClass: "modify-button bg-primary",
              attrs: { href: "#", title: "Muokkaan tietoja" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.modify()
                }
              }
            },
            [_c("i", { staticClass: "fa fa-pencil-alt" })]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("label", {
      staticClass: "labelTitle",
      domProps: { textContent: _vm._s(_vm.title) }
    }),
    _vm._v(" "),
    _vm.isEmpty && _vm.editable
      ? _c(
          "div",
          [
            _c(
              "b-button",
              {
                attrs: { type: "button", variant: "outline-primary" },
                on: {
                  click: function($event) {
                    return _vm.modify()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("Lisää tiedot")))]
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.isEmpty
      ? _c("div", [
          _c("div", { domProps: { textContent: _vm._s(_vm.name) } }),
          _vm._v(" "),
          _c("div", {
            domProps: { textContent: _vm._s(_vm.contactPerson.Phone) }
          }),
          _vm._v(" "),
          _c("div", {
            domProps: { textContent: _vm._s(_vm.contactPerson.Email) }
          }),
          _vm._v(" "),
          _c("div", { domProps: { textContent: _vm._s(_vm.addressString) } })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }